import React, { useState } from "react";
import styled from "styled-components";
import { Draggable, Droppable, DragDropContext } from "react-beautiful-dnd";

import { Divider } from "vqp-common";
import { IconButton, Icon, Collapse, Checkbox } from "../../common";
import { isRequired } from "../../../utils/validations";

import {
  DetailItem,
  TextInputWithLabel,
  DetailSelectModal,
  TextSelect,
} from "./";
import { Field } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";

import { CALC } from "../../../constants/product";

const Wrapper = styled.div`
  padding: 10px 0;
  ${(props) =>
    props.index % 2 === 0 &&
    `
    background-color: rgba(0,0,0,0.03);
  `}
`;

const Title = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 6fr 1fr 1fr 2fr 1fr;
  grid-gap: 5px;
  align-items: center;
  justify-items: center;
  font-size: 14px;
  color: ${(props) => props.theme.colors.textBold};
`;

const Extra = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 6fr 2fr;
  grid-gap: 5px;
  align-items: center;
  justify-items: center;
  font-size: 14px;
  color: ${(props) => props.theme.colors.textBold};
`;

const CheckboxWrapper = styled.div`
  font-size: 10px;
`;

const DeleteWrapper = styled.div`
  margin-left: auto;
`;

const DetailWrapper = styled.div`
  margin-left: 30px;
`;

const DroppableContainer = styled.div``;

const DetailsContainer = styled.div``;

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 0;
`;

const StyledIconButton = styled(IconButton)`
  font-size: 11px !important;
  color: ${(props) => props.theme.colors.primary};
`;

const DragIconWrapper = styled.div`
  ${(props) =>
    !props.isDragEnabled &&
    `
    opacity: 0;
  `}
`;

const CollapseIconWrapper = styled.div`
  cursor: pointer;
  ${(props) =>
    props.collapsed &&
    `
    & > div {
      transform: rotate(90deg)
    }
  `}
`;

export const DetailList = ({
  field,
  index,
  detail = {},
  onToggleDetail,
  isDragEnabled,
  onDelete,
  storeId,
}) => {
  const { name, min, max, isCheckbox, hasDelivery, hasCounter, calcType } =
    detail;
  const itemsLength = detail.items && detail.items.length;
  const [isDetailOpen, setDetailOpen] = useState(
    itemsLength > 0 ? false : true
  );
  const [items, setItems] = useState(detail.items || []);
  const [itemSelectModalOpen, setItemSelectModalOpen] = useState(false);

  const handleDetailItemDrag = (fields) => (result) => {
    if (result.destination) {
      fields.swap(result.source.index, result.destination.index);
      const newItems = [...items];
      const aux = newItems[result.destination.index];
      newItems[result.destination.index] = newItems[result.source.index];
      newItems[result.source.index] = aux;
      for (let i = 0; i < newItems.length; i++) {
        newItems[i].order = i + 1;
      }
      setItems(newItems);
    }
  };

  const toggleDetail = (e) => {
    const newOpen = !isDetailOpen;
    setDetailOpen(newOpen);
    onToggleDetail(newOpen);
  };

  const toggleItemSelectModal = () => {
    setItemSelectModalOpen(!itemSelectModalOpen);
  };

  const handleAddNewItem = (fields) => () => {
    const newItem = {
      code: "",
      name: "",
      price: "",
      description: "",
      order: items.length + 1,
      delivery: true,
      counter: true,
    };
    fields.push(newItem);
    items.push(newItem);
    setItems(items);
  };

  const handleSelectItem = (fields) => (item) => {
    fields.push(item);
    items.push(item);
    setItems(items);
  };

  const handleRemoveItem = (fields, index) => () => {
    fields.remove(index);
    items.splice(index, 1);
    setItems(items);
  };

  return (
    <Draggable
      isDragDisabled={!isDragEnabled}
      type="detail"
      key={`${field}`}
      draggableId={`${field}`}
      index={index}
    >
      {(providedDrag, snapshot) => (
        <>
          <Wrapper
            index={index}
            ref={providedDrag.innerRef}
            {...providedDrag.draggableProps}
            {...providedDrag.dragHandleProps}
          >
            <Title>
              <DragIconWrapper isDragEnabled={isDragEnabled}>
                <Icon name={"drag"} />
              </DragIconWrapper>
              <CollapseIconWrapper
                collapsed={isDetailOpen}
                onClick={toggleDetail}
              >
                <Icon name={"arrowRight"} />
              </CollapseIconWrapper>
              <Field
                name={`${field}.name`}
                initialValue={name}
                validate={isRequired}
              >
                {({ input, meta }) => {
                  const error = meta.touched && meta.error;
                  return (
                    <TextInputWithLabel
                      {...input}
                      error={error && " "}
                      label="Nome"
                      placeholder={"Novo grupo"}
                    />
                  );
                }}
              </Field>
              <Field
                name={`${field}.min`}
                initialValue={min}
                validate={isRequired}
              >
                {({ input, meta }) => {
                  const error = meta.touched && meta.error;
                  return (
                    <TextInputWithLabel
                      {...input}
                      error={error && " "}
                      label="min"
                    />
                  );
                }}
              </Field>
              <Field name={`${field}.max`} initialValue={max}>
                {({ input, meta }) => {
                  const error = meta.touched && meta.error;
                  return (
                    <TextInputWithLabel
                      {...input}
                      error={error && " "}
                      label="max"
                    />
                  );
                }}
              </Field>
              <Field name={`${field}.isCheckbox`} initialValue={isCheckbox}>
                {({ input, meta }) => {
                  // const error = meta.touched && meta.error
                  return (
                    <CheckboxWrapper>
                      <Checkbox checked={input.value} onCheck={input.onChange}>
                        Campo checkbox?
                      </Checkbox>
                    </CheckboxWrapper>
                  );
                }}
              </Field>
              {!isDetailOpen && (
                <DeleteWrapper>
                  <IconButton
                    icon="delete"
                    onClick={onDelete}
                    title={`Excluir`}
                  />
                </DeleteWrapper>
              )}
            </Title>
            <Extra>
              <Field name={`${field}.counter`} initialValue={hasCounter}>
                {({ input, meta }) => {
                  // const error = meta.touched && meta.error
                  return (
                    <CheckboxWrapper>
                      <Checkbox checked={input.value} onCheck={input.onChange}>
                        Balcão
                      </Checkbox>
                    </CheckboxWrapper>
                  );
                }}
              </Field>
              <Field name={`${field}.delivery`} initialValue={hasDelivery}>
                {({ input, meta }) => {
                  // const error = meta.touched && meta.error
                  return (
                    <CheckboxWrapper>
                      <Checkbox checked={input.value} onCheck={input.onChange}>
                        Delivery
                      </Checkbox>
                    </CheckboxWrapper>
                  );
                }}
              </Field>
              <Field
                name={`${field}.calc`}
                initialValue={calcType}
                validate={isRequired}
              >
                {({ input, meta }) => {
                  const error = meta.touched && meta.error;
                  return (
                    <TextSelect
                      {...input}
                      error={error && " "}
                      label="Tipo de Cálculo"
                      selected={input.value}
                      onChange={input.onChange}
                      options={Object.values(CALC)}
                    />
                  );
                }}
              </Field>
            </Extra>
            <Collapse isOpen={isDetailOpen}>
              <DetailWrapper>
                <FieldArray
                  name={`${field}.items`}
                  initialValue={items}
                  subscription={{ submitting: true }}
                >
                  {({ fields }) => (
                    <DragDropContext onDragEnd={handleDetailItemDrag(fields)}>
                      <DetailsContainer>
                        <Droppable
                          type="detailItem"
                          droppableId="droppableDetailItem"
                        >
                          {(providedDrop, snapshot) => (
                            <DroppableContainer
                              {...providedDrop.droppableProps}
                              ref={providedDrop.innerRef}
                            >
                              {fields.map((innerField, i) => {
                                const item = (items && items[i]) || {};
                                return (
                                  <DetailItem
                                    index={i}
                                    field={innerField}
                                    item={item}
                                    onDelete={handleRemoveItem(fields, i)}
                                  />
                                );
                              })}
                              {providedDrop.placeholder}
                            </DroppableContainer>
                          )}
                        </Droppable>
                        <Actions>
                          <StyledIconButton
                            type="button"
                            icon="plusBlue"
                            onClick={handleAddNewItem(fields)}
                          >
                            Novo Item
                          </StyledIconButton>
                          <StyledIconButton
                            type="button"
                            icon="plusBlue"
                            onClick={toggleItemSelectModal}
                          >
                            Usar existente
                          </StyledIconButton>
                        </Actions>
                      </DetailsContainer>
                      <DetailSelectModal
                        isOpen={itemSelectModalOpen}
                        isItem={true}
                        onSelect={handleSelectItem(fields)}
                        onClose={toggleItemSelectModal}
                        storeId={storeId}
                      />
                    </DragDropContext>
                  )}
                </FieldArray>
              </DetailWrapper>
            </Collapse>
          </Wrapper>
          <Divider />
        </>
      )}
    </Draggable>
  );
};
